(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpl-project-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('tpl-project-gallery')) return;
  class TPLProjectGallery extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      const track = this.querySelector('[data-project-track]');
      const slides = Array.from(this.querySelectorAll('[data-project-slide]'));
      if (!track || slides.length < 2) return;
      const thumbnails = Array.from(this.querySelectorAll('[data-project-thumb]'));
      const thumbnailRow = this.querySelector('[data-project-thumbnails]');
      const controls = this.querySelector('[data-project-controls]');
      const counter = this.querySelector('[data-project-current]');
      const previous = this.querySelector('[data-project-step="-1"]');
      const next = this.querySelector('[data-project-step="1"]');
      this._abort = new AbortController();
      const signal = this._abort.signal;
      let active = 0;
      const offset = index => slides[index].offsetLeft - slides[0].offsetLeft;
      const sync = () => {
        let closest = 0;
        slides.forEach((slide, index) => {
          if (Math.abs(offset(index) - track.scrollLeft) < Math.abs(offset(closest) - track.scrollLeft)) closest = index;
        });
        active = closest;
        thumbnails.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
        counter.textContent = String(active + 1);
        previous.disabled = active === 0;
        next.disabled = active === slides.length - 1;
        const selected = thumbnails[active];
        if (selected && thumbnailRow) {
          const left = selected.getBoundingClientRect().left - thumbnailRow.getBoundingClientRect().left + thumbnailRow.scrollLeft;
          if (left < thumbnailRow.scrollLeft || left + selected.offsetWidth > thumbnailRow.scrollLeft + thumbnailRow.clientWidth) {
            thumbnailRow.scrollTo({left: Math.max(0, left - 4), behavior: 'auto'});
          }
        }
      };
      const go = index => {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left: offset(target), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      thumbnails.forEach((button, index) => button.addEventListener('click', () => go(index), {signal}));
      previous.addEventListener('click', () => go(active - 1), {signal});
      next.addEventListener('click', () => go(active + 1), {signal});
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this._frame);
        this._frame = requestAnimationFrame(sync);
      }, {passive: true, signal});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        const destinations = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1};
        if (!(event.key in destinations)) return;
        event.preventDefault();
        go(destinations[event.key]);
      }, {signal});
      this._observer = new ResizeObserver(sync);
      this._observer.observe(track);
      thumbnailRow.hidden = false;
      controls.hidden = false;
      this.setAttribute('data-gallery-ready', '');
      sync();
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._observer?.disconnect();
      cancelAnimationFrame(this._frame);
      this._abort = null;
    }
  }
  customElements.define('tpl-project-gallery', TPLProjectGallery);
})();
  } catch(e) { console.error(e); }
})();

})();
